(function () {
  "use strict";

  const MAX_VISIBLE_COLLAPSED = 9;
  const FILTER_FADE_MS = 400;
  const LIST_HEIGHT_MS = 450;
  const LIST_HEIGHT_EASING = "ease-out";
  const LIST_ITEM_SELECTOR = "li";
  const MQL_REDUCE_MOTION = "(prefers-reduced-motion: reduce)";
  const SCROLL_SETTLE_THRESHOLD_PX = 2;
  const SCROLL_SETTLE_MAX_WAIT_MS = 800;

  const LABEL_VIEW_ALL = "すべて表示する";
  const LABEL_VIEW_LESS = "一部表示に戻す";
  const VIEW_MORE_LESS_CLASS = "is-view-less";

  function prefersReducedMotion() {
    return window.matchMedia(MQL_REDUCE_MOTION).matches;
  }

  function checkedValueSet(nodeList) {
    const set = new Set();
    nodeList.forEach((input) => {
      if (input.checked) {
        set.add(input.value);
      }
    });
    return set;
  }

  class CareerMv {
    constructor(wrap) {
      this.wrap = wrap;
      this.wrap.querySelectorAll(".page-career__mv__nav li").forEach((li) => {
        const cn = li.className;
        const link = li.querySelector("a");
        link.addEventListener("mouseenter", () => {
          this.wrap.classList.add("is-hover", `is-hover--${cn}`);
        });
        link.addEventListener("mouseleave", () => {
          this.wrap.classList.remove("is-hover", `is-hover--${cn}`);
        });
      });
    }
  }

  document.querySelectorAll(".page-career__mv").forEach((mv) => {
    new CareerMv(mv);
  });

  class CareerEntryJobFilter {
    constructor(section) {
      this.filterEl = section.querySelector(".page-career__entry-filter");
      this.listEl = section.querySelector(".page-career__entry-list.--all-list");
      this.countEl = section.querySelector(
        ".page-career__entry-filter-result__count"
      );
      this.viewMoreEl = section.querySelector(".page-career__view-more");
      this.viewMoreBtn = this.viewMoreEl
        ? this.viewMoreEl.querySelector("button")
        : null;
      this.expanded = !this.viewMoreBtn;
      this._filterAnimSeq = 0;
      this._filterHideTimer = null;
      this._listHeightAnimSeq = 0;
      this._listHeightAnimCleanup = null;
      this._collapsePending = false;

      if (!this.filterEl || !this.listEl) {
        return;
      }

      this.jobInputs = this.filterEl.querySelectorAll(
        'input[name="career_job[]"]'
      );
      this.levelInputs = this.filterEl.querySelectorAll(
        'input[name="career_level[]"]'
      );

      this._bindFilterInputs();
      this._bindViewMoreButton();
      this.apply();
    }

    _bindFilterInputs() {
      const onChange = () => {
        if (this.viewMoreBtn) {
          this.expanded = false;
        }
        this.runFilterListTransition();
      };
      this.jobInputs.forEach((input) =>
        input.addEventListener("change", onChange)
      );
      this.levelInputs.forEach((input) =>
        input.addEventListener("change", onChange)
      );
    }

    _bindViewMoreButton() {
      if (!this.viewMoreBtn) {
        return;
      }
      this.viewMoreBtn.addEventListener("click", () => {
        if (this._collapsePending) {
          return;
        }
        const nextExpanded = !this.expanded;
        if (prefersReducedMotion()) {
          if (!nextExpanded) {
            this.collapseAfterScroll();
            return;
          }
          this.expanded = nextExpanded;
          this.apply();
          return;
        }
        if (nextExpanded) {
          // 展開時の高さアニメーションによるちらつきを避けるため即時展開する
          this.expanded = true;
          this.apply();
        } else {
          this.collapseAfterScroll();
        }
      });
    }

    collapseAfterScroll() {
      this._collapsePending = true;
      this.scrollToPageTop().then(() => {
        requestAnimationFrame(() => {
          this.expanded = false;
          this.apply();
          this._collapsePending = false;
        });
      });
    }

    waitForScrollSettled(targetTop) {
      return new Promise((resolve) => {
        const startedAt = performance.now();
        let stableFrameCount = 0;
        const check = () => {
          const delta = Math.abs(window.pageYOffset - targetTop);
          stableFrameCount =
            delta <= SCROLL_SETTLE_THRESHOLD_PX ? stableFrameCount + 1 : 0;
          if (
            stableFrameCount >= 2 ||
            performance.now() - startedAt >= SCROLL_SETTLE_MAX_WAIT_MS
          ) {
            resolve();
            return;
          }
          requestAnimationFrame(check);
        };
        requestAnimationFrame(check);
      });
    }

    scrollToPageTop() {
      const targetTop = 0;
      window.scrollTo(0, targetTop);
      return this.waitForScrollSettled(targetTop);
    }

    resetListHeightStyles(ul) {
      if (!ul) {
        return;
      }
      ul.style.height = "";
      ul.style.overflow = "";
      ul.style.transition = "";
    }

    abortListHeightAnim() {
      this._listHeightAnimSeq += 1;
      if (this._listHeightAnimCleanup) {
        this._listHeightAnimCleanup();
        this._listHeightAnimCleanup = null;
      }
      this.resetListHeightStyles(this.listEl);
    }

    _measureListHeightPx(ul) {
      return Math.round(ul.getBoundingClientRect().height);
    }

    _lockListHeight(ul, heightPx) {
      ul.style.height = `${heightPx}px`;
      ul.style.overflow = "hidden";
    }

    _runListHeightTransition(ul, endH, mySeq) {
      const durationMs = LIST_HEIGHT_MS;
      let finished = false;

      const finish = () => {
        if (finished || mySeq !== this._listHeightAnimSeq) {
          return;
        }
        finished = true;
        window.clearTimeout(fallbackTimer);
        ul.removeEventListener("transitionend", onEnd);
        this._listHeightAnimCleanup = null;
        this.resetListHeightStyles(ul);
      };

      const onEnd = (e) => {
        if (e.target !== ul || e.propertyName !== "height") {
          return;
        }
        finish();
      };

      ul.addEventListener("transitionend", onEnd);
      const fallbackTimer = window.setTimeout(finish, durationMs + 80);

      this._listHeightAnimCleanup = () => {
        window.clearTimeout(fallbackTimer);
        ul.removeEventListener("transitionend", onEnd);
        this.resetListHeightStyles(ul);
      };

      requestAnimationFrame(() => {
        if (mySeq !== this._listHeightAnimSeq) {
          return;
        }
        ul.style.transition = `height ${durationMs}ms ${LIST_HEIGHT_EASING}`;
        void ul.offsetHeight;
        ul.style.height = `${endH}px`;
      });
    }

    _restoreListOpacityAfterLayout(seq) {
      requestAnimationFrame(() => {
        if (seq !== this._filterAnimSeq) {
          return;
        }
        requestAnimationFrame(() => {
          if (seq !== this._filterAnimSeq) {
            return;
          }
          this.listEl.style.opacity = "1";
        });
      });
    }

    runFilterListTransition() {
      this.abortListHeightAnim();
      if (prefersReducedMotion()) {
        this.apply();
        return;
      }
      if (this._filterHideTimer) {
        clearTimeout(this._filterHideTimer);
        this._filterHideTimer = null;
      }
      const seq = (this._filterAnimSeq += 1);
      this.listEl.style.opacity = "0";
      this._filterHideTimer = setTimeout(() => {
        this._filterHideTimer = null;
        if (seq !== this._filterAnimSeq) {
          return;
        }
        this.apply();
        this._restoreListOpacityAfterLayout(seq);
      }, FILTER_FADE_MS);
    }

    updateEntryListDom() {
      const jobsChecked = checkedValueSet(this.jobInputs);
      const levelsChecked = checkedValueSet(this.levelInputs);
      const hasJobFilter = jobsChecked.size > 0;
      const hasLevelFilter = levelsChecked.size > 0;
      let matched = 0;
      let shownInCollapsed = 0;

      this.listEl.querySelectorAll(LIST_ITEM_SELECTOR).forEach((li) => {
        const job = li.getAttribute("data-career-job");
        const level = li.getAttribute("data-career-level");
        const passesJob = !hasJobFilter || jobsChecked.has(job);
        const passesLevel = !hasLevelFilter || (!!level && levelsChecked.has(level));
        const passesFilter = passesJob && passesLevel;
        if (!passesFilter) {
          li.hidden = true;
          return;
        }
        matched += 1;
        const shouldHideByCollapse =
          !!this.viewMoreBtn &&
          !this.expanded &&
          shownInCollapsed >= MAX_VISIBLE_COLLAPSED;
        li.hidden = shouldHideByCollapse;
        if (!shouldHideByCollapse) {
          shownInCollapsed += 1;
        }
      });

      if (this.countEl) {
        this.countEl.textContent = String(matched);
      }

      if (this.viewMoreEl && this.viewMoreBtn) {
        const needsMore = matched > MAX_VISIBLE_COLLAPSED;
        this.viewMoreEl.hidden = !needsMore;
        const label = this.expanded ? LABEL_VIEW_LESS : LABEL_VIEW_ALL;
        this.viewMoreBtn
          .querySelectorAll(".fore > span, .back > span")
          .forEach((span) => {
            span.textContent = label;
          });
        this.viewMoreBtn.setAttribute(
          "aria-expanded",
          String(this.expanded && needsMore)
        );
        this.viewMoreBtn.classList.toggle(
          VIEW_MORE_LESS_CLASS,
          this.expanded && needsMore
        );
      }
    }

    apply() {
      this.abortListHeightAnim();
      this.updateEntryListDom();
    }

    animateAllListExpand() {
      const ul = this.listEl;
      this.abortListHeightAnim();
      const mySeq = this._listHeightAnimSeq;

      const startH = this._measureListHeightPx(ul);
      this._lockListHeight(ul, startH);

      this.expanded = true;
      this.updateEntryListDom();

      let endH = ul.scrollHeight;
      if (endH <= startH) {
        ul.style.height = "";
        endH = Math.round(ul.offsetHeight);
        ul.style.height = `${startH}px`;
        if (endH <= startH) {
          this.resetListHeightStyles(ul);
          return;
        }
      }

      this._runListHeightTransition(ul, endH, mySeq);
    }

    animateAllListCollapse() {
      const ul = this.listEl;
      this.abortListHeightAnim();
      const mySeq = this._listHeightAnimSeq;

      const startH = this._measureListHeightPx(ul);
      this._lockListHeight(ul, startH);
      void ul.offsetHeight;

      this.expanded = false;
      this.updateEntryListDom();

      ul.style.height = "";
      const endH = Math.round(ul.offsetHeight);
      ul.style.height = `${startH}px`;
      void ul.offsetHeight;

      if (endH >= startH) {
        this.resetListHeightStyles(ul);
        return;
      }

      this._runListHeightTransition(ul, endH, mySeq);
    }
  }

  const careerEntrySection = document.querySelector(".page-career__entry");
  if (careerEntrySection) {
    new CareerEntryJobFilter(careerEntrySection);
  }
})();
